import {Component, Inject} from '@angular/core';
import {StateModule} from '@webmate-web-core/shared/components/state/state.module';
import {SliderModule} from 'primeng/slider';
import {FormsModule} from '@angular/forms';
import {ButtonModule} from 'primeng/button';
import {ModalToolContainerService} from '@webmate-web-core/shared/tools/modaltoolcontainer/modaltoolcontainer.service';
import {ToolsModule} from '@webmate-web-core/shared/tools/tools.module';
import {FactsModule} from '@webmate-web-core/shared/components/facts/facts.module';
import {ArtifactService} from '@webmate-web-core/shared/services/artifact.service';
import {Artifact} from '@webmate-web-core/shared/types/artifact';
import {SelectModule} from 'primeng/select';
import {MenuItem} from 'primeng/api';
import {DOCUMENT} from '@angular/common';
import {MenuModule} from 'primeng/menu';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faAdjust} from '@fortawesome/pro-solid-svg-icons';
import {ScreenshotModule} from '@webmate-web-core/shared/components/screenshot/screenshot.module';
import {ImageService} from '@webmate-web-core/shared/services/image.service';
import {StateInfoItem} from '@webmate-web-core/shared/components/state/stateinfoitemrendererfactory';
import {ImageEditorToolComponent, ImageEditorToolConfig} from '@webmate-web-core/shared/tools/screenshotviewer/image-editor.component';


@Component({
    templateUrl: './showcase.component.html',
    styleUrls: ['./showcase.component.less'],
    standalone: true,
    imports: [StateModule, SliderModule, FormsModule, ButtonModule, ToolsModule, FactsModule, SelectModule, MenuModule, FontAwesomeModule, ScreenshotModule]

})
export class ShowcaseComponent {

    size: number = 1200;

    themes: 'light' | 'dark' | 'highcontrast' = 'light';
    themeOptions: MenuItem[] = [
        {label: 'Light', command: () => this.setTheme('light')},
        {label: 'Dark', command: () => this.setTheme('dark')},
        {label: 'High Contrast', command: () => this.setTheme('highcontrast')}
    ];

    artifact: Artifact;

    infoItems: StateInfoItem[] = [];

    constructor(private toolService: ModalToolContainerService, private artifactService: ArtifactService, @Inject(DOCUMENT) private document: Document, private imageService: ImageService) {

    }

    ngOnInit() {
        this.opentool();
    }

    setTheme(theme: string) {
        this.document.documentElement.setAttribute('data-theme', theme);
    }

    opentool() {
        this.toolService.openTool(ImageEditorToolComponent, new ImageEditorToolConfig('1b232687-9f99-40a9-8958-da4c4423c531'));
    }

    protected readonly faAdjust = faAdjust;
}
